export const YMETRICA_COUNTER = 49147447;
export const YMETRICA_DEBUG_FLAG = '_ym_debug';
